var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 778.26 765.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009eb4;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M778.26,382.74C778.26,594.13,604,765.5,389.13,765.5S0,594.13,0,382.74,174.22,0,389.13,0,778.26,171.36,778.26,382.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.79,702.76,669.67,545.62a18.15,18.15,0,0,0,3.38-25.5L380.6,138.84a18.31,18.31,0,0,0-16.83-7L216,151.25a18.27,18.27,0,0,0-14.45,11.11L144.45,300.1a18.19,18.19,0,0,0,2.37,18L439.29,699.41A18.18,18.18,0,0,0,464.79,702.76ZM255,267a30.34,30.34,0,1,1,42.54,5.62A30.34,30.34,0,0,1,255,267Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.3,48.62A5.74,5.74,0,0,1,93.42,44c2.39-1,5,.42,5.71,3.25,19.56,72.7,72.44,85,111.05,94,13.59,3.18,25.34,5.92,33.45,10.81,34.59,20.88,23.64,75.1,23.54,75.62-.63,3-3.1,4.86-5.52,4.25s-3.93-3.47-3.3-6.46c.39-1.9,9.26-46.46-19.08-63.57-7-4.26-18.25-6.87-31.22-9.89-38.42-9-96.47-22.5-117.58-101a6.63,6.63,0,0,1-.17-2.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/icon10.7c3917cf58f68530343f3960279f1d7f.svg";
export { ForwardRef as ReactComponent };